import { useEffect } from "react";

import type { CatalystPredictorState } from "#src/contexts/catalyst";
import { useCatalystContext } from "#src/contexts/catalyst";

/** Stores relevant predictor information in the Catalyst Context */
export function SyncCatalystPredictorState({
  state,
}: {
  state: CatalystPredictorState;
}) {
  const { setPredictor } = useCatalystContext();

  useEffect(() => {
    setPredictor?.(state);
  }, [setPredictor, state]);

  // Clear the predictor state when the component unmounts. Putting this cleanup
  // in the useEffect above is undesireable because it results in the predictor
  // state temporarily being set to undefined whenever a change is made to the
  // model, which in turn affects the predictor observer functions.
  useEffect(() => {
    return () => setPredictor?.(undefined);
  }, [setPredictor]);

  return null;
}
